export default "__VITE_ASSET__CRCvEExR__"